import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PriceRequestGroup, PriceRequestInbox } from '@shared/services/price-request-inbox.service';
import { PriceRequestRefreshModalComponent } from '@shared/modals/price-request-refresh/price-request-refresh-modal.component';

@Component({
  selector: 'app-notifications-modal',
  templateUrl: './notifications-modal.component.html',
  styleUrls: ['./notifications-modal.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
})
export class NotificationsModalComponent {
  private readonly activeModal = inject(NgbActiveModal);
  private readonly modalService = inject(NgbModal);
  readonly inbox = inject(PriceRequestInbox);

  openRefresh(group: PriceRequestGroup): void {
    this.activeModal.dismiss();
    const ref = this.modalService.open(PriceRequestRefreshModalComponent, { size: 'lg', centered: true });
    ref.componentInstance.group = group;
  }

  close(): void {
    this.activeModal.dismiss();
  }
}
